import React, { Component } from 'react';
import { connect } from 'react-redux'
import _get from 'lodash/get'
import { reminderStyle, loaderStyle, countDownStyle, reminderOptionStyle, justifyContent, reminderMobileDetail } from './style.js'
import MolaHandler from '@api/mola'
import { getContentTypeName } from '@source/lib/globalUtil'
import history from '../../history'
import { addReminder, deleteReminder } from '@actions/reminders'

class ReminderMatch extends Component {
  state = {
    statusReminder: '',
    action: '',
    isReminderActive: '',
    isLoading: false,
    isAnimate: false,
    showTooltip: false,
    isAnimateMobile: false
  }

  componentDidMount() {
    const { reminder } = this.props
    if (reminder) {
      this.setState({
        isReminderActive: reminder.status
      })
    } else {
      this.setState({
        isReminderActive: 0
      })
    }
  }

  clickAddReminder = (id) => {
    const {
      countDown,
      isMobile,
      user: { token, uid = '', sid = '' },
    } = this.props
    this.setState({
      isLoading: true,
      showTooltip: false,
      isAnimate: false,
      // isAnimateMobile: true
    })
    MolaHandler.postReminder(token, id).then((response) => {
      if (response.meta.status === 'SUCCESS') {
        this.setState({
          isReminderActive: true,
          isLoading: false,
          // isAnimateMobile: false
        })
      }
    })
  }
  clickDeleteReminder = (id) => {
    const {
      countDown,
      isMobile,
      user: { token, uid = '', sid = '' },
    } = this.props
    this.setState({
      isLoading: true,
      showTooltip: false,
      // isAnimate: false,
      // isAnimateMobile: true
    })
    MolaHandler.deleteReminder(token, id).then((response) => {
      if (response.meta.status === 'SUCCESS') {
        this.setState({
          isReminderActive: false,
          isLoading: false,
          // isAnimateMobile: false
        })
      } else {
        this.setState({
          isReminderActive: true,
          isLoading: false,
          // isAnimateMobile: false
        })
      }
    })
      .catch((err) => {
        this.setState({
          isReminderActive: true,
          isLoading: false
        })
      })
  }

  handleClickReminderPage = () => {
    history.push('/accounts/profile?tab=watchList')
  }

  handleClick = (id, clickType) => {
    const {
      user: { uid = '', sid = '' },
    } = this.props

    const isLogin = uid || sid
    if (isLogin) {
      if (clickType === 'delete') {
        this.clickDeleteReminder(id)
      } else if (clickType === 'add') {
        this.clickAddReminder(id)
      }
    } else {
      const redirectUri = _get(document, 'location.href', '')
      window.location.href = `/accounts/login?redirect_uri=${encodeURIComponent(redirectUri)}`
    }
  }

  redirectToPage = () => {
    const {
      runtime: { isMobile },
      configParams
    } = this.props
    if (isMobile) {
      const btpMenuLabel = _get(configParams, 'naming.reminder.btp_menu_label', null)
      history.push(`/accounts/profile?tab=watchList&sub=reminders&btp=${btpMenuLabel || ''}`)
    } else {
      history.push('/accounts/profile?tab=watchList&sub=reminders')
    }
  }

  handleMouseEnter = () => {
    this.setState({
      isAnimate: true,
      showTooltip: true,
    })
  }

  handleMouseLeave = () => {
    this.setState({
      isAnimate: false,
      showTooltip: false
    })
  }

  renderIcon = () => {
    const {
      runtime: { isMobile }
    } = this.props
    const { isLoading, isReminderActive } = this.state
    if (isMobile) {
      if (isReminderActive) {
        return (
          // <div
          //   className={`reminder-icon-active ${this.props.isMatchCard && 'large'}
          //   ${this.state.isAnimateMobile ? 'animate_icon_mobile' : ''}`}
          // >
          <div
            className={`reminder-icon-active ${this.props.isMatchCard && 'large'}`}
          >
          </div>
        )
      } else {
        return (
          // <div
          //   className={`reminder-icon ${this.props.isMatchCard && 'large'}
          //   ${this.state.isAnimateMobile ? 'animate_icon_mobile' : ''}`}
          // >
          <div
            className={`reminder-icon ${this.props.isMatchCard && 'large'}`}
          >
          </div>
        )
      }
    } else {
      if (isReminderActive) {
        return (
          // <div
          //   className={`reminder-icon-active ${this.props.isMatchCard && 'large'} 
          //   ${this.state.isAnimate ? 'animate_icon' : ''}`}
          // >
          <div
            className={`reminder-icon-active ${this.props.isMatchCard && 'large'}`}
          >
          </div>
        )
      } else {
        return (
          <div
            className={`reminder-icon
            ${this.props.isMatchCard && 'large'} ${this.state.isAnimate ? 'animate_icon_inactive' : ''}`}>
            {/* <div
            className={`reminder-icon
            ${this.props.isMatchCard && 'large'}`}> */}
          </div>
        )
      }
    }
  }

  renderReminder = () => {
    const { isLoading, isReminderActive } = this.state
    const { id } = this.props

    const { configParams } = this.props
    const orLabel = _get(configParams, 'naming.matches.or_label', 'atau')
    const reminderText = _get(configParams, 'naming.matches.reminder_text', 'Pengingat')
    const activeRemiderText = _get(configParams, 'naming.matches.active_remider_text', 'Pengingat Aktif')
    const viewReminderListText = _get(configParams, 'naming.matches.view_reminder_list_text', 'Lihat Daftar Pengingat')
    const remindMeText = _get(configParams, 'naming.matches.remind_me_text', 'Ingatkan Saya')

    // if (isLoading) {
    //   return (
    //     <div className={`${loaderStyle}`}>
    //       <div className="lds-ring">
    //         <div></div>
    //         <div></div>
    //         <div></div>
    //         <div></div>
    //       </div>
    //     </div>
    //   )
    // } else {
    if (isReminderActive) {
      if (this.props.mobileDetail) {
        return (
          <>
            <div className={`${reminderMobileDetail}`} onClick={() => this.handleClick(id, 'delete')}>
              {this.renderIcon()}
              <div className="reminder-text-active">{reminderText}</div>
            </div>
          </>
        )
      } else {
        return (
          <>
            <div
              onMouseLeave={this.handleMouseLeave}
              onMouseEnter={this.handleMouseEnter}
              className={`${reminderStyle}`} onClick={() => this.handleClick(id, 'delete')}>
              {
                this.props.iconOnly && (<div className={`tooltip ${this.state.showTooltip ? 'show_tooltip' : ''}`}>
                  <div className="tooltip-text">{activeRemiderText}</div>
                  <div className="arrow"></div>
                </div>)
              }
              {this.renderIcon()}
              {
                !this.props.iconOnly && (<div className="reminder-text-active">{activeRemiderText}</div>)
              }
            </div>
            {
              this.props.countDownOpt && (
                <div className={`${reminderOptionStyle}`}>
                  <div className="reminder-divider-text">{orLabel}</div>
                  <div className="reminder-gtp-text" onClick={this.redirectToPage}>{viewReminderListText}</div>
                </div>
              )
            }
          </>
        )
      }

    } else {
      if (this.props.mobileDetail) {
        return (
          <div className={`${reminderMobileDetail}`} onClick={() => this.handleClick(id, 'add')}>
            {this.renderIcon()}
            <div className="reminder-text">{reminderText}</div>
          </div>
        )
      } else {
        return (
          <>
            <div
              onMouseLeave={this.handleMouseLeave}
              onMouseEnter={this.handleMouseEnter}
              className={`${reminderStyle}`}
              onClick={() => this.handleClick(id, 'add')}>
              {
                this.props.iconOnly && (<div className={`tooltip ${this.state.showTooltip ? 'show_tooltip' : ''}`}>
                  <div className="tooltip-text">{remindMeText}</div>
                  <div className="arrow"></div>
                </div>)
              }
              {this.renderIcon()}
              {
                !this.props.iconOnly && (<div className="reminder-text">{remindMeText}</div>)
              }
            </div>
          </>
        )
      }
    }
  }

  render() {
    const { id, reminder } = this.props
    const { isReminderActive } = this.state
    return (
      <>
        {
          this.renderReminder()
        }
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addReminder: (id, page) => dispatch(addReminder(id, page)),
    deleteReminder: (id) => dispatch(deleteReminder(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReminderMatch)